import { RootState as state } from 'editor/src/store/index';

// if there is no page index specified return spread's first page and it's background color
const getPageBackgroundColor = (store: state, spreadIndex: number, pageIndex?: number) =>
  store.design.designData?.spreads[spreadIndex]?.pages[pageIndex ?? 0]?.backgroundColor;
export default getPageBackgroundColor;
